import { useEffect, useState } from "react";
import Countdown from "react-countdown";

export default function ClientCountdown({
  timestamp,
  countdownPrefix,
}: {
  timestamp: Date;
  countdownPrefix?: string;
}) {
  const [clientDate, setClientDate] = useState<Date>();
  const [isClient, setIsClient] = useState<boolean>(false);

  useEffect(() => {
    if (timestamp) {
      setIsClient(true);
      setClientDate(timestamp);
    }
  }, [timestamp]);

  if (!isClient) {
    return null;
  }

  if (!clientDate) {
    return null;
  }

  return (
    <Countdown
      date={new Date(clientDate)}
      renderer={({
        days,
        hours,
        minutes,
        // seconds,
        completed,
      }: {
        days: number;
        hours: number;
        minutes: number;
        // seconds: number;
        completed: boolean;
      }) => {
        if (completed) {
          return "Closed";
        } else {
          return countdownPrefix
            ? `${countdownPrefix} ${days}d ${hours}h ${minutes}m`
            : `${days}d ${hours}h ${minutes}m`;
        }
      }}
    />
  );
}
